import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PagePermissionMap } from 'src/constants/permissions';
import { AuthenticationData } from 'src/shared/models/authentication-data';
import { Page } from './tabs/tabs-meta';
import * as fp from "lodash/fp";

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly _permissions = new BehaviorSubject<Array<string>>([]);
  public permissions$ = this._permissions.asObservable();

  constructor() { }

  async init(data: Array<string> | AuthenticationData) {
    let permissions = data instanceof AuthenticationData
      ? fp.get("jwt.Module", data)
      : data;
    permissions = permissions || [];
    permissions = Array.isArray(permissions) ? permissions : [permissions];
    this._permissions.next(permissions);
  }

  purge() {
    this._permissions.next([]);
  }

  hasPermission(permission: string) {
    return this._permissions.value && this._permissions.value.some(p => p === permission);
  }

  isAccessiblePage(page: Page): boolean {
    const pagePermissionCheck = PagePermissionMap[page];
    if (pagePermissionCheck)
      return pagePermissionCheck(this._permissions.value) ?? false;

    return false;
  }
}
